import { AbstractControl, ValidationErrors, FormGroup } from '@angular/forms';

export function validateMinimumPaymentValue(control: AbstractControl): ValidationErrors | null {
    const minimumPaymentValue = control.value;
    const totalValue = control.root.get('total.value');

    if (totalValue !== null && totalValue !== undefined) {
        if (minimumPaymentValue <= 0) {
            return { 'invalidMinimumPaymentValue': true };
        }

        if (minimumPaymentValue >= totalValue.value) {
            return { 'minimumGreaterThanTotal': true };
        }

        return null;
    } else {
        return null;
    }
}

export function validateNoPreSelect(control: AbstractControl): ValidationErrors | null {
    const selectedValue = control.value;
    if (selectedValue && selectedValue.toLowerCase() === 'elija' || selectedValue && selectedValue.toLowerCase() === 'seleccione') {
        return { invalidDocumentType: true };
    }
    return null;
}



